import React, { useContext } from 'react';
import { navigate, RouteComponentProps } from '@reach/router';
import {
  Dropdown,
  DropdownButton,
  DropdownContent,
  DropdownDivider,
  DropdownMenuGroup,
  ButtonSize,
  DropdownDropDirection,
  DropdownAlignment,
} from 'react-magma-dom';
import { StyledDropdownMenuItemEmail, StyledLink, StyledDropdownMenuItem } from '../Styled/StyledDropDownMenu';
import { AccountCircleIcon } from 'react-magma-icons';
import { authAPI } from '../../API/auth';
import { EditToolContext } from '../../contexts/editToolContext';
import { ACCESS_CODE } from '../../constants';

export const DropDownMenu: React.FC<RouteComponentProps> = (): JSX.Element => {
  const { handleLeavePage } = useContext(EditToolContext);

  const handleLogout = () => {
    if (!handleLeavePage(authAPI.logout, false)) {
      authAPI.logout();
    }
  };

  return (
    <Dropdown dropDirection={DropdownDropDirection.left} width="182px" alignment={DropdownAlignment.start}>
      <DropdownButton aria-label="Go to account page" size={ButtonSize.small} icon={<AccountCircleIcon />} />{' '}
      <DropdownContent>
        <DropdownMenuGroup header="Logged in as:">
          <StyledDropdownMenuItemEmail id="inspectletIgnore">
            {localStorage.getItem('email')}{' '}
          </StyledDropdownMenuItemEmail>
        </DropdownMenuGroup>
        <DropdownDivider />
        <StyledLink onClick={e => handleLeavePage(() => navigate(`/${ACCESS_CODE}`), false, e)} to={ACCESS_CODE}>
          <StyledDropdownMenuItem>ENTER ACCESS CODE</StyledDropdownMenuItem>
        </StyledLink>
        <DropdownDivider />
        <DropdownMenuGroup>
          <StyledDropdownMenuItem onClick={handleLogout}>LOGOUT</StyledDropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownContent>
    </Dropdown>
  );
};
